import { Injectable } from "@angular/core";
import { BehaviorSubject, of } from "rxjs";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthModel } from "../models/auth.model";
import { User } from "../core/models/user";
import { AuthService } from "./auth.service";

@Injectable()
export class UsersService {
  API_USERS_URL = `${environment.apiUrl}`;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };
  dataChange: BehaviorSubject<AuthModel[]> = new BehaviorSubject<AuthModel[]>([]);
  // Temporarily stores data from dialogs
  dialogData: any;
  constructor(private httpClient: HttpClient, private authService: AuthService,
  ) { }
  get data(): AuthModel[] {
    return this.dataChange.value;
  }


  getAllUsersList(): Observable<any> {
    const auth = this.authService.getAuthFromLocalStorage();
    if (!auth || !auth.token) {
      return of(undefined);
    }
    return this.httpClient
      .get<any>(`${this.API_USERS_URL}/users/all`, {
        headers: new HttpHeaders({

          'Authorization': 'Bearer ' + auth.token,

          'Accept': 'application/json'

        })

      })
      .pipe(catchError(this.errorHandler));
  }

  getAllUsers(page): Observable<any> {
    const auth = this.authService.getAuthFromLocalStorage();
    if (!auth || !auth.token) {
      return of(undefined);
    }
    return this.httpClient
      .get<any>(`${this.API_USERS_URL}/users?page=` + page, {
        headers: new HttpHeaders({

          'Authorization': 'Bearer ' + auth.token,

          'Accept': 'application/json'

        })

      });
  }

  SearchUsersList(user: any, page: any): Observable<any> {


    var formData: any = new FormData();
    formData.append("name", user.name);
    formData.append("email", user.email);
    formData.append("phone", user.phone);
    formData.append("cnic", user.cnic);
    formData.append("page", page);

    const auth = this.authService.getAuthFromLocalStorage();
    if (!auth || !auth.token) {
      return of(undefined);
    }
    return this.httpClient.post<any>(`${this.API_USERS_URL}/users/search`, formData,
      {
        headers: new HttpHeaders({

          'Authorization': 'Bearer ' + auth.token,

          'Accept': 'application/json'

        })

      });
  }

  importlist(user: any): Observable<any> {
    console.log(user);

    var formData: any = new FormData();
    formData.append("name", user.name);
    formData.append("email", user.email);
    formData.append("phone", user.phone);
    formData.append("cnic", user.cnic);


    const auth = this.authService.getAuthFromLocalStorage();
    if (!auth || !auth.token) {
      return of(undefined);
    }


    return this.httpClient.post<any>(`${this.API_USERS_URL}/users/import`, formData,
      {
        headers: new HttpHeaders({

          'Authorization': 'Bearer ' + auth.token,

          'Accept': 'application/json'

        })

      });
  }
  addUsers(user: User, profile_avatar: String): Observable<any> {
    var formData: any = new FormData();
    formData.append("name", user.name);
    formData.append("email", user.email);
    formData.append("phone", user.phone);
    formData.append("cnic", user.cnic);
    formData.append("site_location", user.site_location);
    formData.append("employee_no", user.employee_no);
    formData.append("profile_avatar", profile_avatar);
    formData.append("Group_ID", user.Group_ID);

    const auth = this.authService.getAuthFromLocalStorage();
    if (!auth || !auth.token) {
      return of(undefined);
    }

    return this.httpClient.post<any>(`${this.API_USERS_URL}/users/`, formData,
      {
        headers: new HttpHeaders({

          'Authorization': 'Bearer ' + auth.token,

          'Accept': 'application/json'

        })

      });
  }

  UpdateUsers(user: User, profile_avatar: String): Observable<any> {

    var formData: any = new FormData();
    formData.append("name", user.name);
    formData.append("email", user.email);
    formData.append("phone", user.phone);
    formData.append("cnic", user.cnic);
    formData.append("site_location", user.site_location);
    formData.append("employee_no", user.employee_no);
    formData.append("profile_avatar", profile_avatar);
    formData.append("Group_ID", user.Group_ID);

    const auth = this.authService.getAuthFromLocalStorage();
    console.log(auth);
    if (!auth || !auth.token) {
      return of(undefined);
    }
    return this.httpClient.post<any>(`${this.API_USERS_URL}/users/` + user.id, formData,
      {
        headers: new HttpHeaders({

          'Authorization': 'Bearer ' + auth.token,

          'Accept': 'application/json'

        })

      });
  }
  deleteUsers(id: any): Observable<any> {


    const auth = this.authService.getAuthFromLocalStorage();
    if (!auth || !auth.token) {
      return of(undefined);
    }
    return this.httpClient.delete(`${this.API_USERS_URL}/users/` + id,
      {
        headers: new HttpHeaders({

          'Authorization': 'Bearer ' + auth.token,

          'Accept': 'application/json'

        })

      });

  }
  errorHandler(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
